import { render, staticRenderFns } from "./HeaderTitre.vue?vue&type=template&id=2b6d797f&"
import script from "./HeaderTitre.vue?vue&type=script&lang=js&"
export * from "./HeaderTitre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports